module.exports = __webpack_public_path__ + "static/media/host-home.a855a2ef.png";